module.exports = __webpack_public_path__ + "img/ic_qmarker_generic_lbl.700d304b.png";